import { render, staticRenderFns } from "./recoverDialog.vue?vue&type=template&id=d15b3fda&"
import script from "./recoverDialog.vue?vue&type=script&lang=js&"
export * from "./recoverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports